export default class AdminApplicationsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.applicationsEndpoint, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  createAccessToken(application_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.applicationsEndpoint}/${application_id}/access-token/generate`)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.applicationsEndpoint}/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  assignApplicationsToUser(id, payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.applicationsEndpoint}/users/${id}/grant`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.applicationsEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.applicationsEndpoint, {
      params
    })
  }
}
